import { useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { Flex, Text } from "@/ui";
import Icon from "@/components/Icon";
import IconButton from "@/components/IconButton";
import { t } from "@/utils";
import environment from "@/modules/environment";
import Close from "assets/icons/close.svg?react";
import Warning from "assets/icons/error_outlined.svg?react";

const compatibilityBannerKey = `${environment.appMode}-compatibility-banner-dismissed`;

export default function CompatibilityBanner() {
  const [isDismissed, setIsDismissed] = useState(() => window.localStorage.getItem(compatibilityBannerKey) === "true");

  const handleClose = () => {
    window.localStorage.setItem(compatibilityBannerKey, "true");
    setIsDismissed(true);
  };
  const isSafari = environment.system.isBrowser("safari");

  if (!isSafari) return null;

  return (
    <AnimatePresence initial={false}>
      {!isDismissed && (
        <Flex
          as={motion.div}
          initial={{ opacity: 0, height: 0, y: -8 }}
          animate={{ opacity: 1, height: "auto", y: 0 }}
          exit={{ opacity: 0, height: 0, y: -8 }}
          sx={{ transition: { duration: 0.22, ease: "easeOut" } }}
          overflow="hidden"
          top="0"
          zIndex={100}
          gap="10"
          py="4"
          pr="10"
          bg="orange-container"
          mx={["-1rem", "-1.5rem"]}
          align="center"
          justifyContent="center"
        >
          <Flex flexGrow={1} justifyContent="center" alignItems="center" gap="10">
            <Icon icon={Warning} fill="on-orange-container" size="20px" />
            <Text color="on-orange-container" fontSize="12px" fontWeight={500}>
              {t("browserWarning")}
            </Text>
          </Flex>

          <IconButton
            icon={Close}
            fill="on-orange-container"
            onClick={handleClose}
            iconSize="24px"
            p="4"
            tooltip={{ label: t("buttons.close") }}
          />
        </Flex>
      )}
    </AnimatePresence>
  );
}
